export const QUIRE_WALLET_CHAIN = "ethchain/CONNECT_CHAIN"
export const CHANGE_WALLET_CHAIN = "ethchain/CHANGE_CHAIN"
export const CHAIN_MAINET = "1";
export const CHAIN_TESTNET = "0";
export const CHAIN_NONENET = "-1";
export const MAIN_NET =  process.env.REACT_APP_MAIN_NET
export const CONNECT_WALLET = "ethchain/CONNECT_WALLET"
export const CHANGE_WALLET_STATUS = "ethchain/CHANGE_WALLET_STATUS"